import type { Role } from '../../../../shared/types/index.js';

export type ProfileSection = 'details' | 'name' | 'password';

export interface RoleBadgeConfig {
  bg: string;
  text: string;
  border: string;
  pill: string;
  label: string;
  desc: string;
}

export const getRoleBadgeInfo = (role: Role | string): RoleBadgeConfig => {
  const mapping: Record<string, RoleBadgeConfig> = {
    penulis: {
      bg: 'bg-sky-50',
      text: 'text-sky-700',
      border: 'border-sky-200',
      pill: 'bg-sky-100 text-sky-900',
      label: 'Penulis Mandiri',
      desc: 'Memiliki hak registrasi naskah mandiri, pengajuan UIBN, serta pengelolaan karya pribadi.',
    },
    penerbit: {
      bg: 'bg-purple-50',
      text: 'text-purple-700',
      border: 'border-purple-200',
      pill: 'bg-purple-100 text-purple-900',
      label: 'Penerbit Resmi',
      desc: 'Penerbit terverifikasi dengan alokasi kode unik penerbit UIBN resmi.',
    },
    organisasi: {
      bg: 'bg-amber-50',
      text: 'text-amber-800',
      border: 'border-amber-200',
      pill: 'bg-amber-100 text-amber-900',
      label: 'Organisasi / Komunitas',
      desc: 'Komunitas / organisasi terverifikasi untuk menerbitkan karya internal langsung ke sistem UIBN.',
    },
    admin: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      pill: 'bg-emerald-100 text-emerald-900',
      label: 'Administrator Platform',
      desc: 'Pengelola pusat registrasi, kurasi, dan katalog UIBN.',
    },
  };

  return mapping[role] || {
    bg: 'bg-slate-50',
    text: 'text-slate-700',
    border: 'border-slate-200',
    pill: 'bg-slate-100 text-slate-900',
    label: role,
    desc: 'Pengguna terdaftar sistem UIBN.',
  };
};

export interface PasswordStrengthResult {
  score: number;
  text: string;
  color: string;
}

export const getPasswordStrength = (pass: string): PasswordStrengthResult => {
  if (!pass) return { score: 0, text: '', color: 'bg-slate-200' };
  let score = 0;
  if (pass.length >= 6) score += 1;
  if (pass.length >= 10) score += 1;
  if (/[A-Z]/.test(pass) && /[a-z]/.test(pass)) score += 1;
  if (/[0-9]/.test(pass) || /[^A-Za-z0-9]/.test(pass)) score += 1;

  switch (score) {
    case 1:
      return { score: 25, text: 'Sangat Lemah', color: 'bg-rose-500' };
    case 2:
      return { score: 50, text: 'Cukup', color: 'bg-amber-500' };
    case 3:
      return { score: 75, text: 'Kuat', color: 'bg-indigo-500' };
    case 4:
    default:
      return { score: 100, text: 'Sangat Aman', color: 'bg-emerald-500' };
  }
};
